// import { getS3FileContent } from "@/pages/api/cache-pages";
// import { AWS_STRAPI_JSON_DATA_FOLDER_NAME } from "@/utils/utils";

import axios, { AxiosInstance } from "axios";

export const api: AxiosInstance = axios.create({
  baseURL: process.env.CMS_API_BASE_URL,
});

export const fetchSingleTypeData = async (locale: string): Promise<any> => {
  try {
    const response = await api.get(`api/home-page?locale=${locale}`);
    return response.data;
  } catch (error) {
    console.error(`Error fetching data from home-page:`, error);
    return null;
  }
};

export const CmsCoursePages = async (
  param: string,
  locale?: string
): Promise<any> => {
  try {
    const query = locale
      ? `?filters[slug][$eq]=${param}&locale=${locale}`
      : `?filters[slug][$eq]=${param}`;
    const response = await api.get(`api/program-detail-pages${query}`);
    return response.data;
  } catch (error) {
    console.error("Error fetching CMS data:", error);
    return null;
  }
};

export const CmsAllCousesList = async (locale?: string): Promise<any> => {
  try {
    const query = locale ? `?locale=${encodeURIComponent(locale)}` : "";
    const response = await api.get(`api/program-detail-pages${query}`);
    return response.data;
  } catch (error) {
    console.error(`Error fetching data from home-page:`, error);
    return null;
  }
};
export const CmsAllSchoolList = async (locale?: string): Promise<any> => {
  try {
    const query = locale ? `?locale=${encodeURIComponent(locale)}` : "";
    const response = await api.get(`api/school-pages${query}`);
    return response.data;
  } catch (error) {
    console.error(`Error fetching data from School-page:`, error);
    return null;
  }
};

export const CmsSchoolPages = async (
  params: string,
  locale?: string
): Promise<any> => {
  try {
    const query = locale
      ? `?filters[slug][$eq]=${params}&locale=${locale}`
      : `?filters[slug][$eq]=${params}`;
    const response = await api.get(`api/school-pages${query}`);
    return response.data;
  } catch (error) {
    console.error("Error fetching CMS data:", error);
    return null;
  }
};
export const CmsEventPages = async (
  params: string,
  locale: string = "en"
): Promise<any> => {
  try {
    const response = await api.get(
      `api/event-detail-pages?filters[slug][$eq]=${params}&locale=${locale}`
    );
    return response.data;
  } catch (error) {
    console.error("Error fetching CMS data:", error);
    return null;
  }
};

export const fetchContactData = async (): Promise<any> => {
  try {
    const response = await api.get(`api/contact-us`);
    return response.data;
  } catch (error) {
    console.error(`Error fetching data from contact-page:`, error);
    return null;
  }
};
export const fetchMegamenuData = async (locale?: string): Promise<any> => {
  try {
    const query = locale ? `?locale=${locale}` : "";
    const response = await api.get(`api/common-page${query}`);
    return response.data;
  } catch (error) {
    console.error(`Error fetching data from contact-page:`, error);
    return null;
  }
};

export const fetchAboutData = async (): Promise<any> => {
  try {
    const response = await api.get(`api/about-us`);
    return response.data;
  } catch (error) {
    console.error(`Error fetching data from about-page:`, error);
    return null;
  }
};

export const fetchPolicyData = async (): Promise<any> => {
  try {
    const response = await api.get(`api/privacy-policy`);
    return response.data;
  } catch (error) {
    console.error(`Error fetching data from policy-page:`, error);
    return null;
  }
};
export const fetchTermsConditionData = async (): Promise<any> => {
  try {
    const response = await api.get(`api/terms-and-condition`);
    return response.data;
  } catch (error) {
    console.error(`Error fetching data from policy-page:`, error);
    return null;
  }
};

export const fetchAccreditationData = async (): Promise<any> => {
  try {
    const response = await api.get(`api/accreditations-page`);
    return response.data;
  } catch (error) {
    console.error(`Error fetching data from accreditiation-page:`, error);
    return null;
  }
};

export const fetchLeadershipPageData = async (): Promise<any> => {
  try {
    const response = await api.get(`api/leadership-page`);
    return response;
  } catch (error) {
    console.error(`Error fetching data from accreditiation-page:`, error);
    return null;
  }
};

export const fetchSuccessStoryData = async (): Promise<any> => {
  try {
    const response = await api.get(`api/success-story`);
    return response;
  } catch (error) {
    console.error(`Error fetching data from accreditiation-page:`, error);
    return null;
  }
};

export const CmsUgpgPages = async (
  params: string,
  locale?: string
): Promise<any> => {
  try {
    const query = locale
      ? `?filters[slug][$eq]=${params}&locale=${locale}`
      : `?filters[slug][$eq]=${params}`;
    const response = await api.get(`api/ug-pgs${query}`);
    return response.data;
  } catch (error) {
    console.error("Error fetching CMS data:", error);
    return null;
  }
};

export const fetchAboutUsData = async (): Promise<any> => {
  try {
    const response = await api.get(`api/about-us`);
    return response.data;
  } catch (error) {
    console.error(`Error fetching data from home-page:`, error);
    return null;
  }
};
export const fetchEventsData = async (locale: string = "en"): Promise<any> => {
  try {
    const response = await api.get(`api/event?locale=${locale}`);
    return response.data;
  } catch (error) {
    console.error(`Error fetching data from event:`, error);
    return null;
  }
};

export const fetchAllProgramPageData = async (): Promise<any> => {
  try {
    const response = await api.get(`api/all-programs-page
`);
    return response.data;
  } catch (error) {
    console.error(`Error fetching data from home-page:`, error);
    // const AllAcademicData = await getS3FileContent(
    //   `${AWS_STRAPI_JSON_DATA_FOLDER_NAME}/all-programs-page.json`
    // );
    // return AllAcademicData;
  }
};

export const fetchSchoolFundingData = async (): Promise<any> => {
  try {
    const response = await api.get(`api/student-funding-option`);
    return response.data;
  } catch (error) {
    console.error(`Error fetching data from home-page:`, error);
    // const StudentLoandData = await getS3FileContent(
    //   `${AWS_STRAPI_JSON_DATA_FOLDER_NAME}/student-funding-option.json`
    // );
    // return StudentLoandData;
  }
};
export const fetchAlumnipPageData = async (): Promise<any> => {
  try {
    const response = await api.get(`api/alumni-page`);
    return response.data;
  } catch (error) {
    console.error(`Error fetching data from alumni-page:`, error);
    // const AlumniData = await getS3FileContent(
    //   `${AWS_STRAPI_JSON_DATA_FOLDER_NAME}/alumni-page.json`
    // );
    // return AlumniData;
  }
};
export const fetchAllProgramNamesList = async (): Promise<any> => {
  try {
    const response = await api.get(`api/program-of-interest`);
    return response.data;
  } catch (error) {
    console.error(`Error fetching data from home-page:`, error);
    return null;
  }
};

// GET: Check if alumni user exists by phone number or email
export const checkAlumniUserExists = async (
  phoneNumber: string,
  email: string
): Promise<any> => {
  try {
    const response = await api.get(
      `api/alumni-user-informations?filters[$or][0][phone_number][$eq]=${encodeURIComponent(
        phoneNumber
      )}&filters[$or][1][email][$eq]=${encodeURIComponent(email)}`
    );
    return response.data;
  } catch (error) {
    console.error("Error checking alumni user existence:", error);
    return null;
  }
};

// POST: Register a new alumni user
export const registerAlumniUser = async (alumniPayload: any): Promise<any> => {
  try {
    // Format the payload according to Strapi's requirements
    const formattedPayload = {
      data: {
        full_name: alumniPayload.full_name,
        email: alumniPayload.email,
        student_number: alumniPayload.student_number,
        most_recent_qualification: alumniPayload.most_recent_qualification,
        current_occupation: alumniPayload.current_occupation,
        company_name: alumniPayload.company_name,
        phone_number: alumniPayload.phone_number,
        graduation_year: alumniPayload.graduation_year,
        date_of_birth: alumniPayload.date_of_birth,
      },
    };

    const response = await api.post(
      "api/alumni-user-informations",
      formattedPayload,
      {
        headers: {
          "Content-Type": "application/json",
        },
      }
    );
    return response.data;
  } catch (error) {
    console.error("Error registering alumni user:", error);
    if (axios.isAxiosError(error)) {
      console.error("API Error Response:", error.response?.data);
    }
    return null;
  }
};

export const fetchCommunityEngagementsData = async (): Promise<any> => {
  try {
    const response = await api.get(`api/community-engagement`);
    return response.data;
  } catch (error) {
    console.error(`Error fetching data from home-page:`, error);
    return null;
  }
};

export const fetchFacultyPageData = async (): Promise<any> => {
  try {
    const response = await api.get(`api/faculty-and-insight`);
    return response.data;
  } catch (error) {
    console.error(`Error fetching data from faculty-page:`, error);
    return null;
  }
};
export const fetchCareerPageData = async (locale?: string): Promise<any> => {
  try {
    const query = locale ? `?locale=${encodeURIComponent(locale)}` : "";
    const response = await api.get(`api/career-page${query}`);
    return response.data;
  } catch (error) {
    console.error(`Error fetching data from career-page:`, error);
    return null;
  }
};
export const fetchJobData = async (locale?: string): Promise<any> => {
  try {
    const query = locale ? `?locale=${encodeURIComponent(locale)}` : "";
    const response = await api.get(`api/job-data${query}`);
    return response.data;
  } catch (error) {
    console.error(`Error fetching data from job-data:`, error);
    return null;
  }
};
export const CmsCarrerDetailPage = async (
  params: string,
  locale?: string
): Promise<any> => {
  try {
    const localeQuery = locale ? `&locale=${encodeURIComponent(locale)}` : "";
    const response = await api.get(
      `api/career-detail-pages?filters[slug][$eq]=${encodeURIComponent(
        params
      )}${localeQuery}`
    );
    return response.data;
  } catch (error) {
    console.error("Error fetching CMS data:", error);
    return null;
  }
};
export const CmsCarrerDetailAllPageData = async (
  locale?: string
): Promise<any> => {
  try {
    const query = locale ? `?locale=${encodeURIComponent(locale)}` : "";
    const response = await api.get(`api/career-detail-pages${query}`);
    return response.data;
  } catch (error) {
    console.error(`Error fetching data from career-detail-pages:`, error);
    return null;
  }
};

export const postEventUserData = async (formData: any): Promise<any> => {
  try {
    const response = await api.post("/api/event-user-datas", {
      data: {
        name: formData?.name || "",
        phone_number: formData?.mobileNumber || "",
        email: formData?.email || "",
        program_of_interest: formData?.course || null,
        highest_qualification: formData?.qualification || null,
        study_mode: formData?.mode || null,
        event_name: formData?.event_name || "Default Event",
      },
    });
    return response.data;
  } catch (error) {
    console.error("Error posting event user data:", error);
    return null;
  }
};

export const postCareerUserData = async (formData: any): Promise<any> => {
  try {
    const response = await api.post("/api/career-user-datas", {
      data: {
        name: formData.name,
        email: formData.email,
        phone_number: formData.phoneNumber,
        resume_url: formData.resumeUrl,
      },
    });
    return response.data;
  } catch (error) {
    console.error("Error posting career user data:", error);
    return null;
  }
};

export const CmsLPCoursePages = async (param: string): Promise<any> => {
  try {
    const response = await axios.get(
      `${process.env.CMS_API_BASE_URL_LP}/api/landing-pages?filters[slug][$eq]=${param}`
    );
    return response.data;
  } catch (error) {
    console.error("Error fetching CMS data:", error);
    return null;
  }
};

export const CmsCountryPages = async (
  param: string,
  locale?: string
): Promise<any> => {
  try {
    const query = locale
      ? `?filters[slug][$eq]=${param}`
      : `?filters[slug][$eq]=${param}`;
    const response = await api.get(`api/country-home-pages${query}`);
    return response.data;
  } catch (error) {
    console.error("Error fetching CMS data:", error);
    return null;
  }
};

export default api;
